import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Message } from 'element-ui';
import { addTag, addScene } from '@blade-sxp/device-management/api/device-management/index';
let default_1 = class default_1 extends Vue {
    dialogVisible;
    eidtChange;
    type;
    formData = {
        name: '',
    };
    // formData rules
    get rules() {
        return {
            name: [{ required: true, message: this.returnRule, trigger: 'blur' }],
        };
    }
    mounted() {
        // this.getTree();
        this.formData = {
            name: '',
        };
    }
    get returnTitle() {
        if (this.type === 'keyArea') {
            return `${this.$t('keyArea')}`;
        }
        else {
            return `${this.$t('label')}`;
        }
    }
    get returnRule() {
        if (this.type === 'keyArea') {
            return `${this.$t('inputRuleKeyArea')}`;
        }
        else {
            return `${this.$t('inputRulelabel')}`;
        }
    }
    handleClose() {
        this.$emit('update:dialogVisible', false);
    }
    submitClose() {
        if (this.type === 'keyArea') {
            let param = {
                sceneName: String(this.formData.name).trim(),
            };
            addScene(param).then((res) => {
                if (res) {
                    this.$emit('addSuccess');
                    this.handleClose();
                    Message.success(`${this.$t('success')}`);
                }
            });
        }
        else {
            let param = {
                tagName: String(this.formData.name).trim(),
            };
            addTag(param).then((res) => {
                if (res) {
                    this.$emit('addSuccess');
                    this.handleClose();
                    Message.success(`${this.$t('success')}`);
                }
            });
        }
    }
    submit() {
        const form = this.$refs.deviceForm;
        form.validate((valid) => {
            if (valid) {
                this.submitClose();
            }
        });
    }
};
__decorate([
    Prop()
], default_1.prototype, "dialogVisible", void 0);
__decorate([
    Prop()
], default_1.prototype, "eidtChange", void 0);
__decorate([
    Prop()
], default_1.prototype, "type", void 0);
default_1 = __decorate([
    Component({
        name: 'model',
        components: {},
        i18n: {
            messages: {
                en: {
                    label: 'Label Name',
                    keyArea: 'KeyArea Name',
                    confirm: 'Confirm',
                    cancel: 'Cancel',
                    inputRulelabel: 'Please enter the label name',
                    inputRuleKeyArea: 'Please enter the KeyArea name',
                    success: 'Added successfully',
                },
                zh: {
                    label: '标签名称',
                    keyArea: '重点区域名称',
                    confirm: '确定',
                    cancel: '取消',
                    inputRulelabel: '请输入标签名称',
                    inputRuleKeyArea: '请输入区域名称',
                    success: '添加成功',
                },
            },
        },
    })
], default_1);
export default default_1;
